import Column from "@avinet/adaptive-ui-core/layout/Column";

export interface DisplayDataTitleProps {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
}

export function DisplayDataTitle({
  title,
  description,
}: DisplayDataTitleProps) {
  return (
    <Column align="left">
      <h4>{title}</h4>
      {description && <p>{description}</p>}
    </Column>
  );
}
